import CalendarInput from "@libs/forms/CalendarInput";
import InputField from "@libs/forms/InputField";
import InputPhone from "@libs/forms/InputPhone";
import { MAX_LENGTH } from "@libs/forms/utils/constants";
import { sanitizeEmail, sanitizeName } from "@libs/forms/utils/sanitations";
import RaQFormContentWrapper from "@modules/requestAQuote/components/RaQFormContentWrapper";
import TripPreferences from "@modules/requestAQuote/components/TripPreferences";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

const LayoutBStepOne = ({
  isOnStickyRaQ,
  calendarInputProps,
  tripPreferencesProps,
  infoUser,
}: any): JSX.Element => {
  const formContext = useFormContext();

  useEffect(() => {
    if (infoUser) {
      const { fullName, email, phoneNumber } = infoUser;
      if (fullName) formContext.setValue("fullName", fullName);
      if (email) formContext.setValue("email", email);
      if (phoneNumber) formContext.setValue("phoneNumber", phoneNumber);
    }
  }, [infoUser]);

  return (
    <RaQFormContentWrapper>
      <div className="mb-6 flex flex-col gap-[24px]">
        <InputField
          name="fullName"
          label="Full Name"
          type="name"
          hasAsterisk={true}
          maxLength={MAX_LENGTH.name}
          sanitize={sanitizeName}
          isOnStickyRaQ={isOnStickyRaQ}
        />
        <InputField
          name="email"
          label="Email"
          type="email"
          hasAsterisk={true}
          maxLength={MAX_LENGTH.email}
          sanitize={sanitizeEmail}
          isOnStickyRaQ={isOnStickyRaQ}
        />
        <InputPhone
          label="Phone"
          name="phoneNumber"
          isOnStickyRaQ={isOnStickyRaQ}
        />
        <CalendarInput
          {...calendarInputProps}
          label="Travel Dates"
          isOnStickyRaQ={isOnStickyRaQ}
        />
      </div>
      <TripPreferences {...tripPreferencesProps} />
    </RaQFormContentWrapper>
  );
};

export default LayoutBStepOne;
